<template>
  <div :class="$style.root">
    <img :class="$style.bg" :src="config.bgImg" />
    <template v-if="step > 10">
      <UserCharacter :class="$style.character" />
      <ModeDisplay :class="$style.modeDisplay" v-bind="mode" />
    </template>
    <template v-if="step == 10">
      <ModeSelector @mode="handleMode" :bgColor="config.modeColor" :unlocked="unlocked" />
    </template>
    <template v-if="step == 20">
      <component
        :is="introComponent"
        :class="$style.intro"
        @end="handleIntroEnd"
      />
    </template>
    <template v-if="step == 100">
      <component
        :is="exerciseComponent"
        :class="$style.content"
        :aside="380"
        :history="history"
        :questions.sync="questions"
        @end="handleExerciseEnd"
      />
    </template>
    <template v-if="step == 200">
      <Result :historyId="history.id" :class="$style.content" />
    </template>
  </div>
</template>

<script>
import UserCharacter from '@/components/UserCharacter'
import ModeSelector from '@/components/ModeSelector'
import ModeDisplay from '@/components/ModeDisplay'
import introComponents from '@/components/Introduction'
import exerciseComponents from '@/components/Exercise'
import { mapActions, mapGetters, mapState } from 'vuex'
import Result from '@/components/Exercise/Result'

export default {
  components: {
    UserCharacter,
    ModeSelector,
    ModeDisplay,
    Result,
  },
  props: {
    exercise: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      mode: null,
      introduced: false,
      loading: false,
      ended: false,
      history: null,
      questions: [],
    }
  },
  computed: {
    introComponent () {
      return introComponents[this.exercise]
    },
    exerciseComponent () {
      return exerciseComponents[this.exercise]
    },
    config () {
      return this.thumbs.find(({ key }) => key == this.exercise)
    },
    modeCompleted () {
      return !!this.mode
    },
    introCompleted () {
      return this.introduced
    },
    step () {
      if (!this.modeCompleted) {
        return 10
      }
      if (!this.introduced) {
        return 20
      }
      if (!this.ended) {
        return 100
      }
      return 200
    },
    unlocked () {
      return this.typeUnlocks(this.exercise)
    },
    ...mapGetters('auth', {
      typeUnlocks: 'typeUnlocks',
    }),
    ...mapState({
      thumbs: 'thumbs',
    }),
  },
  methods: {
    async init() {
      //
    },
    async initExercise () {
      try {
        let history
        if (!history) {
          history = await this.createHistory()
        }
        this.history = history
      } catch (e) {
        //
      }
    },
    async getLastHistory () {
      try {
        const { data } = await this.httpGet({ url: '/history', query: { page_size: 1 } })
        const lastHistory = data[0]
        return lastHistory
      } catch (e) {
        //
      }
    },
    async createHistory () {
      try {
        const { data } = await this.httpPost({
          url: '/history',
          data: {
            type: this.exercise,
            level: this.mode.level,
            time_limited: this.mode.limit,
          },
        })
        return data
      } catch (e) {
        //
      }
    },
    handleMode (mode) {
      this.mode = mode
      this.initExercise()
    },
    handleIntroEnd () {
      this.introduced = true
    },
    async handleExerciseEnd () {
      this.ended = true
      try {
        await this.getProfile()
      } catch (e) {
        //
      }
    },
    ...mapActions('http', {
      httpGet: 'get',
      httpPost: 'post',
    }),
    ...mapActions('auth', {
      getProfile: 'getProfile',
    }),
  },
}
</script>

<style lang="scss" module>
.root {
  @apply h-full;
  @apply w-full;
  @apply relative;
  display: grid;
  grid-template-rows: 60px 1fr 380px 60px;
  grid-template-columns: 380px 1fr;
  grid-template-areas:
    ". ."
    ". content"
    "character content"
    ". content";
}

.bg {
  grid-row: 1 / span 4;
  grid-column: 1 / span 2;
  @apply w-full;
  @apply h-full;
  @apply object-cover;
  @apply object-center;
}

.character {
  grid-area: character;
  @apply m-4;
}

.modeDisplay {
  @apply absolute;
  top: 0;
  left: 0;
}

.intro {
  grid-column: 2;
  grid-row: 2 / span 2;
  height: 500px;
  @apply mx-4;
}

.content {
  grid-column: 1 / span 2;
  grid-row: 2 / span 3;
}
</style>
